import { EBuildingClass } from '@/packages/JsonQuery';

import { type IBuildingClassOption } from '../types';

const BUILDING_CLASS_TO_LABEL: { [key in EBuildingClass]: string } = {
  [EBuildingClass.A]: 'A',
  [EBuildingClass.B]: 'B',
  [EBuildingClass.C]: 'C',
  [EBuildingClass.D]: 'D',
};

export const OFFICE_BUILDING_CLASS_OPTIONS: IBuildingClassOption[] = mapOptions([
  EBuildingClass.A,
  EBuildingClass.B,
  EBuildingClass.C,
]);

export const COMMON_BUILDING_CLASS_OPTIONS: IBuildingClassOption[] = mapOptions([
  EBuildingClass.A,
  EBuildingClass.B,
  EBuildingClass.C,
  EBuildingClass.D,
]);

function mapOptions(values: EBuildingClass[]): IBuildingClassOption[] {
  return values.map<IBuildingClassOption>(key => ({
    label: BUILDING_CLASS_TO_LABEL[key],
    value: key,
  }));
}
